import React from 'react';
import styles from './JumpToShotButton.module.scss';
import { Icon } from 'components/common';
import { icons } from 'assets';
import { JumpToButtonProps, directionTypes } from '../types';

const JumpToShotButton = (props: JumpToButtonProps) => {
  const {
    direction, onClick, disabled
  } = props;

  const arrowIcon = {
    [directionTypes.previous]: icons.arrowFillLeft,
    [directionTypes.next]: icons.arrowFillRight
  }[direction];
  const title = {
    [directionTypes.previous]: 'Jump To Previous Shot Start',
    [directionTypes.next]: 'Jump To Next Shot Start'
  }[direction];

  const cameraIconStyles = [styles.cameraIcon];
  direction === directionTypes.previous && cameraIconStyles.push(styles.flipHorizontally);
  const containerStyles = [styles.container];
  disabled && containerStyles.push(styles.disabled);

  return (
    <div
      className={containerStyles.join(' ')}
      title={title}
      onClick={disabled ? null : onClick}
    >
      <Icon
        icon={icons.videoCamera}
        className={cameraIconStyles.join(' ')}
      />
      <Icon
        icon={arrowIcon}
        className={styles[direction]}
      />
    </div>
  );
};

export default JumpToShotButton;
